import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OffersV4Hero from './OffersV4Hero';
import OffersV4Slider from './OffersV4Slider';
import OffersV4LoanAmountDialog from './OffersV4LoanAmountDialog';

const ENTRANCE_ANIMATION_SESSION_KEY = 'offersV4CountUpPlayed';

class OffersV4LoanOfferDetails extends Component {
    static propTypes = {
        amount: PropTypes.number.isRequired,
        minOffer: PropTypes.number.isRequired,
        maxOffer: PropTypes.number.isRequired,
        onAmountChange: PropTypes.func.isRequired,
        onEditClick: PropTypes.func.isRequired,
        isDialogOpen: PropTypes.bool.isRequired,
        onDialogClose: PropTypes.func.isRequired,
        onDialogSubmit: PropTypes.func.isRequired,
    };

    static ANIMATION_STEP = 500;

    static ANIMATION_DURATION_MS = 1200;

    static ANIMATION_DELAY = 300;

    constructor(props) {
        super(props);
        const alreadyPlayed = sessionStorage.getItem(ENTRANCE_ANIMATION_SESSION_KEY) === 'true';
        const shouldAnimate = !alreadyPlayed && props.amount > props.minOffer;
        this.state = {
            animatedAmount: shouldAnimate ? props.minOffer : props.amount,
            isAnimating: shouldAnimate,
        };
    }

    componentDidMount() {
        if (this.state.isAnimating) {
            sessionStorage.setItem(ENTRANCE_ANIMATION_SESSION_KEY, 'true');
            this.animationDelayTimer = setTimeout(() => {
                this.startEntranceAnimation();
            }, OffersV4LoanOfferDetails.ANIMATION_DELAY);
        }
    }

    componentWillUnmount() {
        if (this.animationDelayTimer) {
            clearTimeout(this.animationDelayTimer);
        }
        if (this.animationTimer) {
            clearInterval(this.animationTimer);
        }
    }

    startEntranceAnimation() {
        const { minOffer, amount } = this.props;
        const { ANIMATION_STEP, ANIMATION_DURATION_MS } = OffersV4LoanOfferDetails;
        const totalSteps = Math.max(1, Math.ceil((amount - minOffer) / ANIMATION_STEP));
        const stepInterval = ANIMATION_DURATION_MS / totalSteps;

        let current = minOffer;
        this.animationTimer = setInterval(() => {
            current = Math.min(current + ANIMATION_STEP, amount);
            if (current >= amount) {
                clearInterval(this.animationTimer);
                this.setState({ animatedAmount: amount, isAnimating: false });
            } else {
                this.setState({ animatedAmount: current });
            }
        }, stepInterval);
    }

    render() {
        const { amount, minOffer, maxOffer, onAmountChange, onEditClick, isDialogOpen, onDialogClose, onDialogSubmit } = this.props;
        const { animatedAmount, isAnimating } = this.state;
        const displayedAmount = isAnimating ? animatedAmount : amount;

        return (
            <div className="offers-v4-loan-offer-details">
                <OffersV4Hero
                    amount={displayedAmount}
                    onEditClick={onEditClick}
                />
                <OffersV4Slider
                    minOffer={minOffer}
                    maxOffer={maxOffer}
                    value={displayedAmount}
                    disabled={isAnimating}
                    onChange={onAmountChange}
                />
                <OffersV4LoanAmountDialog
                    isOpen={isDialogOpen}
                    onClose={onDialogClose}
                    onSubmit={onDialogSubmit}
                    currentAmount={amount}
                    minAmount={minOffer}
                    maxAmount={maxOffer}
                />
            </div>
        );
    }
}

export default OffersV4LoanOfferDetails;
